import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { API } from "@/lib/api";
import { Trophy, Award, ChevronRight, Star } from "lucide-react";

function photo(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${API.replace(/\/api$/, "")}${url}`;
}

export default function HomeGauravStrip() {
  const [top, setTop] = useState([]);
  const [ref, setRef] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/contributor/top-contributors", { params: { limit: 3 } }).then((r) => setTop(r.data)).catch(() => {}),
      api.get("/contributor/leaderboard", { params: { limit: 1 } }).then((r) => setRef(r.data)).catch(() => {}),
    ]);
  }, []);

  if (top.length === 0 && ref.length === 0) return null;

  const champ = ref[0];

  return (
    <section className="mb-8 rounded-xl border-2 border-amber-200 bg-gradient-to-r from-amber-50 via-orange-50 to-amber-50 p-4 md:p-5 shadow-sm" data-testid="home-gaurav-strip">
      <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
        {/* Left: Trophy label */}
        <div className="shrink-0 flex items-center gap-2 md:border-r md:border-amber-200 md:pr-6">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-amber-400 to-orange-500 text-white flex items-center justify-center shadow-md">
            <Trophy className="w-5 h-5"/>
          </div>
          <div>
            <div className="uppercase tracking-[0.22em] text-[9px] text-amber-700 font-black">Community Champions</div>
            <div className="font-devnagri-heading text-lg font-black text-[#0F172A] leading-none mt-0.5">आज के गौरव पाठक</div>
          </div>
        </div>

        {/* Middle: Top 3 avatars */}
        {top.length > 0 && (
          <div className="flex items-center gap-3 flex-1 min-w-0" data-testid="home-top3">
            {top.slice(0, 3).map((c, i) => (
              <div key={`${c.name}-${i}`} className="flex items-center gap-2 min-w-0" data-testid={`home-top-${i}`}>
                <div className="relative shrink-0">
                  {c.photo_url ? (
                    <img src={photo(c.photo_url)} alt="" className="w-11 h-11 rounded-full object-cover border-2 border-white shadow-md ring-2 ring-amber-300"/>
                  ) : (
                    <div className="w-11 h-11 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 text-white flex items-center justify-center font-black text-sm shadow-md ring-2 ring-amber-300">
                      {c.name?.[0] || "?"}
                    </div>
                  )}
                  <div className="absolute -bottom-1 -right-1 text-base leading-none">
                    {i === 0 ? "🥇" : i === 1 ? "🥈" : "🥉"}
                  </div>
                </div>
                <div className="min-w-0 hidden sm:block">
                  <div className="font-bold text-xs text-[#0F172A] truncate max-w-[110px]">{c.name}</div>
                  <div className="text-[10px] text-slate-500 truncate max-w-[110px]">{c.count} रिपोर्ट{c.count > 1 ? "ें" : ""}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Right: Top Referrer with badge */}
        {champ && (
          <div className="shrink-0 flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-lg px-3 py-2 shadow" data-testid="home-champ-ref">
            <Award className="w-4 h-4 shrink-0"/>
            <div className="min-w-0">
              <div className="text-[9px] uppercase tracking-widest text-emerald-100 font-black flex items-center gap-1">
                <Star className="w-2.5 h-2.5 fill-current"/>टॉप रेफरर
              </div>
              <div className="font-bold text-xs truncate max-w-[140px]">{champ.name}</div>
            </div>
            <div className="text-lg font-black leading-none ml-1">+{champ.referred}</div>
          </div>
        )}

        {/* CTA */}
        <Link to="/contribute" className="shrink-0 inline-flex items-center gap-1 bg-[#0F172A] hover:bg-[#1E3A8A] text-white font-bold text-xs px-3 py-2 rounded-md transition" data-testid="home-gaurav-cta">
          योगदान दें <ChevronRight className="w-3.5 h-3.5"/>
        </Link>
      </div>
    </section>
  );
}
